export function orderBy<T extends object>(list: T[] | undefined, sortField: keyof T, isDesc = false) {
    if (!list?.length) {
        return [];
    }

    return list.sort((a, b) => {
        const aVal = a[sortField];
        const bVal = b[sortField];
        let returnVal = 0;
        if (aVal < bVal) {
            returnVal = -1;
        } else if (bVal < aVal) {
            returnVal = 1;
        }

        return isDesc ? -returnVal : returnVal;
    });
}

export function groupBy<T extends object>(
    list: T[] | undefined,
    groupField: keyof T | ((obj: T) => string),
): {
    [key: string]: T[];
} {
    if (!list?.length) {
        return {};
    }

    return list.reduce(
        (
            accum: {
                [key: string]: T[];
            },
            currObj,
        ) => {
            const propName = (typeof groupField === 'function' ? groupField(currObj) : currObj[groupField]) as string;
            if (!accum[propName]) {
                accum[propName] = [];
            }

            accum[propName].push(currObj);
            return accum;
        },
        {},
    );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function flatten(list: any[] | undefined) {
    return list?.reduce((accumulator, currentValue) => {
        if (Array.isArray(currentValue)) {
            return [...accumulator, ...currentValue];
        } else {
            return [...accumulator, currentValue];
        }
    }, []);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function fromPairs(lists: any[][]) {
    let index = -1;
    const length = lists == null ? 0 : lists.length;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result: any = {};

    while (++index < length) {
        const pair = lists[index];
        result[pair[0]] = pair[1];
    }
    return result;
}
